export default theme => ({
  dashboard: {
    minHeight: '100vh',
    width: '100vw',
    padding: 20,
  }
});